import { uploadFile, uploadFilePublic } from "api/upload/uploadFile";
import { uploadFileOnURL } from "api/upload/uploadImgOnR2";
import { v4 as uuidv4 } from "uuid";
import JSZip from "jszip";

// Uploads a file to R2 via the backend's presigned PUT URL flow.
//
// Returns the stored key (e.g. `<uuid>.png` when `opts.noZip` is true,
// `<uuid>.png.gz` otherwise). Display code should treat the result as
// a stored key, not a URL; helpers/postDisplay.js#normalizeMediaUrl
// prepends `/uploads/` and helpers/extractImageFromZip.js handles the
// gz unwrap for legacy callers.
//
// `opts.noZip = true` uploads the raw file directly. Use for images
// and videos that need to render via a plain <img> / <video> tag —
// new post media goes through this path. Brand logos / IFC files
// stay on the legacy zip-wrap path because their downstream consumers
// (editBrandModal, AddprojectAdmin) call extractImageFromZip.
export const uploadFileToServer = async (file, isPublic = false, opts = {}) => {
  const { noZip = false } = opts || {};
  try {
    const fileExt = file?.name?.split(".").pop() || 'bin';
    const baseName = `${uuidv4()}.${fileExt}`;
    const name = noZip ? baseName : `${baseName}.gz`;

    const res = isPublic
      ? await uploadFilePublic({ fileNames: [name] })
      : await uploadFile({ fileNames: [name] });
    if (!res || !res.uploadUrls || !res.uploadUrls[0]) return null;

    let body;
    if (noZip) {
      body = file;
    } else {
      const zip = new JSZip();
      zip.file(file?.name, file);
      body = await zip.generateAsync({ type: "blob" });
    }
    await uploadFileOnURL({ url: res.uploadUrls[0], body });

    return name;
  } catch (error) {
    console.error("Error uploading file to server:", error);
    return null;
  }
};
